import { useEffect } from "react";
import { connect } from "react-redux";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import DocumentRow from "./DocumentRow";
import { Actions as DOCUMENTACTIONS } from "../../store/actions/documentActions";

const DocumentTable = ({ type, rows, getDocuments, loading, jurisdiction }) => {
	console.log("DocumentTable", rows, type);

	useEffect(() => {
		// set loaded right away to avoid a re-trigger
		getDocuments(type);
	}, [type]);

	// console.log('connected',connected,connectLink)
	// if (userPermissions == "None") return <InvalidPermissions />;

	if (!rows || !rows.length) return null;

	return (
		<div className="content px-0">
			<table
				id="table-timesheets"
				className="js-table-sections table table-hover"
			>
				<thead>
					<tr>
						<th style={{ width: "5%" }}></th>
						<th>Name</th>
						<th>Created At</th>
						{/*{taxFormRows?.map((row, index) => {
                                return <th key={row.label}>{row.label}</th>;
                            })}*/}
						<th>Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<DocumentRow
							key={row.id}
							row={row}
						/>
					))}
				</tbody>
			</table>

			<div className="clearfix" />
		</div>
	);
};

const mapStateToProps = (state) => {
	const { jurisdiction } = state.company?.settings || {};

	// eventually check if we have a documents permission; which may expand by type
	const userPermissions = state?.permissions?.my?.permissions?.taxForms;

	return {
		loading: state.documents.loading,
		rows: state.documents?.rows ?? [],
		userPermissions,
		jurisdiction,
		org: state?.company?.settings?.org,
		isAdmin: state?.my?.profile?.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (type) => dispatch(DOCUMENTACTIONS.getDocuments(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTable);
